// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /instagram/accounts/remover
 *
 * Removes an Instagram account by ID, including Go-service cleanup.
 */
import { registerContract } from './validate'

export interface InstagramAccounts_RemoverInput {
instagram_account_id: number
}

registerContract('InstagramAccounts_RemoverInput', {
  instagram_account_id: { type: 'number',  required: true },
})
